import { createBrowserHistory } from 'history';
import { ROUTES } from 'app/core/router/paths';
import { RouteParams } from 'app/core/router/types';

/**
 * @description 結合動態路由的路徑 (path) 與參數 (params)
 * @param args (Object) 帶入 path 和 params
 */
type TArgs =
    { path: ROUTES.SERVICE__QUERY_POLICY__DETAIL, params: RouteParams['ServiceQueryPolicyDetail'] }
  | { path: ROUTES.SERVICE__QUERY_POLICY__DETAIL__CANCEL, params: RouteParams['ServiceQueryPolicyDetailCancel'] }
  | { path: ROUTES.SERVICE__APPLY_CERTEN, params: RouteParams['ServiceApplyCerten'] };

export const combinePathWithParams = (args: TArgs) => {
  return Object.entries(args.params).reduce((path: string, [param, value]) => path.replace(`:${param}`, value), args.path);
};

/**
 * @description 取得 URL search params 值
 * @param searchParamsStr URL search params 字串
 * @param param 欲取得值的 param
 */
export const getURLSearchParams = (searchParamsStr: string, param: string) => {
  const params = new URLSearchParams(searchParamsStr);
  return params.get(param);
};

/**
 * @description Create custom history instance
 */
export const routerHistory = createBrowserHistory({ basename: '/insure' });
